import { isDateString } from 'class-validator';
import { DateUtils } from './date.utils';
import { BOOLEAN_ENUM } from '../../../constants/src';

interface ToNumberOptions {
  default?: number;
  min?: number;
  max?: number;
}

const toLowerCase = (value?: string): string | undefined => {
  if (!value) return;
  return value?.toLowerCase();
};

const trim = (value?: string): string | undefined => {
  if (!value || typeof value !== 'string') return;
  return value?.trim();
};

const toDate = (value?: string): Date | undefined => {
  if (!value) return;
  if (!isDateString(value)) return;

  return DateUtils(value).toDate();
};

const toBoolean = (value?: BOOLEAN_ENUM): boolean | undefined => {
  if (!value || (value && !value.trim())) return;

  value = value.trim().toLowerCase() as BOOLEAN_ENUM;

  return Object.values(BOOLEAN_ENUM).includes(value)
    ? [BOOLEAN_ENUM.ONE, BOOLEAN_ENUM.TRUE].includes(value)
    : undefined;
};

const toNumber = (
  value?: string | number,
  opts: ToNumberOptions = {},
): number | string | undefined => {
  let newValue: number | undefined = undefined;
  const isNotStringNumber = typeof value === 'string' && isNaN(Number(value));
  if (isNotStringNumber) return value;

  if (typeof value === 'undefined') {
    if (typeof opts.default === 'number') newValue = opts.default;
    else return;
  }

  if (typeof newValue === 'undefined') newValue = Number(value);

  if (opts.min && newValue < opts.min) newValue = opts.min;

  if (opts.max && newValue > opts.max) newValue = opts.max;

  return newValue;
};

const toArray = (value?: string, sep = ','): string[] | undefined => {
  if (!value) return;
  return value.split(sep);
};

export default {
  toLowerCase,
  trim,
  toDate,
  toBoolean,
  toNumber,
  toArray,
};
